import { BellRing, Instagram, Linkedin, Twitter } from "lucide-react";

const COLUMNS = [
  {
    title: "Producto",
    links: [
      { label: "Beneficios", href: "#beneficios" },
      { label: "Cómo funciona", href: "#como-funciona" },
      { label: "Precios", href: "#precios" },
    ],
  },
  {
    title: "Compañía",
    links: [
      { label: "Manifiesto", href: "#manifiesto" },
      { label: "FAQ", href: "#faq" },
      { label: "Acceso anticipado", href: "#waitlist" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="footer-container" className="border-t border-white/10">
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
      <div className="grid gap-12 lg:grid-cols-2">
        <div>
          <a href="#inicio" data-testid="footer-logo" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500/15">
              <BellRing className="h-4 w-4 text-emerald-400" />
            </span>
            <span className="font-display text-2xl font-black tracking-tight">YateAviso</span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-500">
            El cobrador automático por WhatsApp para Mypes en Latinoamérica. Hecho con orgullo en
            LatAm.
          </p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Twitter, Linkedin].map((Icon, i) => (
              <a
                key={i}
                href="#inicio"
                aria-label="Red social"
                className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 text-slate-500 transition-all duration-300 hover:border-emerald-500/40 hover:text-emerald-400"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <p className="mono mb-4 text-[11px] uppercase tracking-[0.2em] text-slate-500">{col.title}</p>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-slate-400 transition-colors duration-300 hover:text-emerald-400">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <p className="mono mb-4 text-[11px] uppercase tracking-[0.2em] text-slate-500">Legal</p>
            <ul className="space-y-2.5">
              <li>
                <a data-testid="footer-link-terms" href="#inicio" className="text-sm text-slate-400 transition-colors duration-300 hover:text-emerald-400">
                  Términos de servicio
                </a>
              </li>
              <li>
                <a data-testid="footer-link-privacy" href="#inicio" className="text-sm text-slate-400 transition-colors duration-300 hover:text-emerald-400">
                  Política de privacidad
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <p className="font-display text-outline mt-16 select-none text-center text-[18vw] font-black leading-none lg:text-[11rem]">
        YateAviso
      </p>

      <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
        <p data-testid="footer-copyright" className="mono text-[11px] uppercase tracking-widest text-slate-600">
          © 2026 YateAviso · Todos los derechos reservados
        </p>
        <p className="mono text-[11px] uppercase tracking-widest text-slate-600">
          Lima · CDMX · Bogotá · Santiago
        </p>
      </div>
    </div>
  </footer>
);
